var exports = {
  "kL": "xdde3148b--70e1ac--container",
  "pq": "xdde3148b--70e1ac--info",
  "UU": "xdde3148b--70e1ac--name",
  "WL": "xdde3148b--70e1ac--factoids",
  "o1": "xdde3148b--70e1ac--actions",
  "ed": "xdde3148b--70e1ac--disclaimer",
};

module.exports = exports;
